import { Component } from '@angular/core';
import { ContextService } from 'src/app/shared/services/context-service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
})
export class CardComponent {
  isDarkThemeEnabled: boolean;
  constructor(contextService: ContextService) {
    this.isDarkThemeEnabled = contextService.isDarkTheme();
  }
}
